import { HTTP, route } from '@community_dev/requests'

import { ENDPOINTS } from 'constants/endpoints'
import { request } from 'utils/api'

type TcpaLanguageResponse = {
  data: {
    language: string
    version: number
  }
}

export function getTcpaLanguage(token: string): Promise<TcpaLanguageResponse> {
  return request(ENDPOINTS.TCPA.LEGAL_LIABILITY, { token })
}

export function acceptTcpaLiability({
  token,
  languageVersion,
  clientId,
}: {
  token: string
  languageVersion: number
  clientId: string
}): Promise<unknown> {
  return request(route(ENDPOINTS.TCPA.TCPA_ACCEPT, { clientId }), {
    method: HTTP.POST,
    token,
    body: {
      tcpaLiabilityLanguageVersion: languageVersion,
    },
  })
}
